
import { IonItem, IonList } from '@ionic/react';
import React from 'react'
import Page from '../components/Page';
import runes from '../data/runes';
import runewords from '../data/runewords';

class RuneDetails extends React.Component {

  state = {
    rune: runes[this.props.match.params.rune],
    runeName: this.props.match.params.rune
  }

  renderSockProps() {
    return Object.keys(this.state.rune.sockProps).map((key,i) => 
      <p className="d2font stat" key={i} style={{color: '#538ff7'}}>
        {key} : {this.state.rune.sockProps[key]}
      </p>
    )
  }

  renderOtherProps() {
    return (
      <IonList>
        <IonItem>
          <div style={{display: 'flex', fontSize: 13, fontWeight: 'bold'}}>
            <div style={{flex: 1}}>Find best at</div>
          </div>
        </IonItem>
          <IonItem key={this.state.runeName}>
            <div style={{display: 'flex'}}>
              <div style={{flex: 1, margin: 5, fontSize: 13}}>
                {this.state.rune.boss}, {this.state.rune.difficulty} <br /> 
                <span style={{lineHeight: '23px'}}>drop chance <b>{this.state.rune.dropChance}</b></span>
              </div>
            </div>
          </IonItem>
      </IonList>
    )
  }

  renderRunewords() {
    return (
      <div style={{marginLeft: 10, marginTop: 40}}>
        <h3 style={{textAlign: 'left'}}>Runewords containg {this.props.match.params.rune}</h3>
        {runewords.filter(r => r.runes.includes(this.props.match.params.rune)).map(runeword => (
          <IonItem routerLink={"/runewords/"+runeword.id}>
            <b>{runeword.name}</b>
          </IonItem>
        ))}
      </div>
    )
  }

  render() {

    return (
      <Page title={this.props.match.params.rune + " Rune"}>
        <div style={{textAlign: 'center'}}>
          <h2 className="d2font">{this.state.runeName}</h2>
          <img className="bright" width={40} src={'/assets/runes/'+this.state.runeName+'.png'} />
          <p className="d2font" style={{color: '#538ff7'}}>Required Level: {this.state.rune.level}</p>
          {this.renderSockProps()}
          {this.renderOtherProps()}
          {this.renderRunewords()}
        </div>
      </Page>
    );
  }
}

export default RuneDetails;